import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Select from "react-select";

// CSS
import "../../../css/react-select.css";

// State
import { setSelectedVariant } from "./../../../store/actions/productVariant";

import "./../../../css/react-selectbox.css";

// ===================================================================================
//	Note:
//	API requires variants to be sent as variants[Size-123]: 255
//	variants[variant_title-variant_id]: option_id
// ===================================================================================

class ProductVariant extends Component {
	static propTypes = {
		variant: PropTypes.object,
		onChange: PropTypes.func
	};




	componentWillMount() {
		// Serialize variants so `Select` component can understand then { value: item_id, label: 'some text' }
		this.serializeVariantOptions();

		// console.log("componentWillMount", this.props.product.sku);
		this.props.setSelectedVariant(
			this.props.variant.title + "-" + this.props.variant.id,
			this.props.variant.itemsSerialized[0].value,
			this.props.product
		);



	}

	serializeVariantOptions = () => {
		this.props.variant.itemsSerialized = this.props.variant.items.map((item, j) => {
			return {
				value: item.id,
				label: item.title
			};
		});
	};

	getSelectedOption = variant => {

		//the code below is used to define the .find method when it doesn't exist
		//in internet explorer the .find() method does not exist
		//this is what you call polyfilling the array.prototype.find() method which pretty much means create it

		// https://tc39.github.io/ecma262/#sec-array.prototype.find
		if (!Array.prototype.find) {
			Object.defineProperty(Array.prototype, 'find', {
				value: function (predicate) {
					// 1. Let O be ? ToObject(this value).
					if (this == null) {
						throw new TypeError('"this" is null or not defined');
					}

					var o = Object(this);

					// 2. Let len be ? ToLength(? Get(O, "length")).
					var len = o.length >>> 0;

					// 3. If IsCallable(predicate) is false, throw a TypeError exception.
					if (typeof predicate !== 'function') {
						throw new TypeError('predicate must be a function');
					}

					// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
					var thisArg = arguments[1];

					// 5. Let k be 0.
					var k = 0;

					// 6. Repeat, while k < len
					while (k < len) {
						// a. Let Pk be ! ToString(k).
						// b. Let kValue be ? Get(O, Pk).
						// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
						// d. If testResult is true, return kValue.
						var kValue = o[k];
						if (predicate.call(thisArg, kValue, k, o)) {
							return kValue;
						}
						// e. Increase k by 1.
						k++;
					}

					// 7. Return undefined.
					return undefined;
				},
				configurable: true,
				writable: true
			});
		}


		return this.props.selectedVariants.find((option, i) => {
			return option.variant_id === variant.title + "-" + variant.id;
		});


		// does not work in internet explorer. It why i created the above code to replace it
		// return this.props.selectedVariants.find((option, i) => {
		// 	return option.variant_id === variant.title + "-" + variant.id;
		// });
	};

	render() {
		const variant = this.props.variant;
		const option = this.getSelectedOption(variant);

		// console.log(option);
		console.log(variant.itemsSerialized);

		// Ensure option is set
		const option_id = option === undefined ? null : option.option_id;

		console.log(option_id);

		return (
			<Select
				classNamePrefix="react-select"
				name={`${variant.title}-${variant.id}`}
				value={variant.itemsSerialized.filter(({ value }) => value === option_id)}
				onChange={selection =>
					this.props.setSelectedVariant(
						this.props.variant.title + "-" + this.props.variant.id,
						selection.value,
						this.props.product
					)
				}
				isClearable={false}
				options={variant.itemsSerialized}
			/>
		);
	}
}

const mapStateToProps = state => {
	return { selectedVariants: state.productVariant.variant_options };
};

export default connect(
	mapStateToProps,
	{ setSelectedVariant }
)(ProductVariant);



// WEBPACK FOOTER //
// ./src/components/product/variants/ProductVariantSelect.js